import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Transition as _Transition, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1fb411f2"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "component-variable__flex" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "component-variable__loading-mask" }, null, -1 /* HOISTED */));
const _hoisted_4 = [
    _hoisted_3
];
import { useComponentVariableNodeType } from "src/shared/store/component-graph-v2/composables/useComponentVariableNodeType";
import { computed, toRef, toValue } from "vue";
import ComponentVariableFooter from "./ComponentVariableFooter.vue";
import ComponentVariableHeader from "./ComponentVariableHeader.vue";
import ComponentVariableNodeIcon from "./ComponentVariableNodeIcon.vue";
import ComponentVariableValues from "./ComponentVariableValues.vue";
import { isComponentVariableShown } from "../list/filter/isComponentVariableShown";
import { useComponentVariableStateStore } from "./component-variable-state";
import ComponentVariableKebabMenu from "./kebab-menu/ComponentVariableKebabMenu.vue";
import { isComponentVariableMutable as isComponentVariableMutableTypeGuard } from "src/shared/store/component-mutable/model/ComponentVariableMutable";
import { isComponentSocketMutable as isComponentSocketMutableTypeGuard } from "src/shared/store/component-mutable/model/ComponentSocketMutable";
import ComponentSocketValues from "./socket/ComponentSocketValues.vue";
import { useBuiltComponentSetting } from "src/shared/store/component-built/composables/useBuiltComponentSetting";
import { useComponentSettingMutable } from "src/shared/store/component-mutable/composables/useComponentSettingMutable";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ComponentVariable',
    props: {
        componentId: {},
        variableName: {},
        componentMutableKey: {},
        showHeader: { type: Boolean, default: true },
        isFilterable: { type: Boolean, default: true },
        componentDrawerRouteConfig: {}
    },
    setup(__props) {
        const props = __props;
        const isShown = computed(() => {
            if (!props.isFilterable) {
                return true;
            }
            return isComponentVariableShown(props.variableName, props.componentMutableKey);
        });
        const componentVariableStateStore = useComponentVariableStateStore();
        const isLoading = computed(() => {
            return componentVariableStateStore.isLoading(props.componentMutableKey, props.variableName);
        });
        const error = computed(() => {
            return componentVariableStateStore.getError(props.componentMutableKey, props.variableName);
        });
        const { componentSettingMutable } = useComponentSettingMutable(toRef(props, "componentMutableKey"), toRef(props, "variableName"));
        const isComponentVariableMutable = computed(() => {
            return isComponentVariableMutableTypeGuard(componentSettingMutable.value);
        });
        const isComponentSocketMutable = computed(() => {
            return isComponentSocketMutableTypeGuard(componentSettingMutable.value);
        });
        const { builtComponentSetting } = useBuiltComponentSetting(toRef(props, "componentId"), toRef(props, "variableName"));
        const workingVariantMode = computed(() => {
            const mutable = toValue(componentSettingMutable);
            if (!mutable) {
                return "SINGLE_VARIANT";
            }
            if (isComponentVariableMutableTypeGuard(mutable)) {
                if (mutable.isTranslatable()) {
                    return "MULTI_VARIANT";
                }
                if (mutable.isMultiVariant()) {
                    return "MULTI_VARIANT";
                }
            }
            return "SINGLE_VARIANT";
        });
        const { componentVariableNodeType } = useComponentVariableNodeType(toRef(props, "componentId"), toRef(props, "variableName"));
        const source = computed(() => {
            if (isComponentVariableMutableTypeGuard(componentSettingMutable.value)) {
                return componentSettingMutable.value.getSource();
            }
            return null;
        });
        const displayableNodeTypes = new Set([
            "MEDIATOR",
            "INSTANCE",
        ]);
        const hasDisplayableNodeType = computed(() => {
            if (componentVariableNodeType.value) {
                return (displayableNodeTypes.has(componentVariableNodeType.value) ||
                    source.value === "PARAMETER");
            }
            return false;
        });
        const inlineRtlLayoutVariableTypes = new Set(["IMAGE"]);
        const inlineLtrLayoutVariableTypes = new Set(["BOOLEAN"]);
        const layoutType = computed(() => {
            // multi varian mode is always verticl, otherwise check the type
            if (!builtComponentSetting.value) {
                return "VERTICAL";
            }
            if (workingVariantMode.value === "MULTI_VARIANT") {
                return "VERTICAL";
            }
            if (inlineRtlLayoutVariableTypes.has(builtComponentSetting.value.type)) {
                return "INLINE_RTL";
            }
            if (inlineLtrLayoutVariableTypes.has(builtComponentSetting.value.type)) {
                return "INLINE_LTR";
            }
            return "VERTICAL";
        });
        const layoutClass = computed(() => {
            if (layoutType.value === "INLINE_RTL") {
                return "component-variable--layout-inline-rtl";
            }
            if (layoutType.value === "INLINE_LTR") {
                return "component-variable--layout-inline-ltr";
            }
            return "component-variable--layout-vertical";
        });
        const styleClass = computed(() => {
            var _a;
            if (((_a = builtComponentSetting.value) === null || _a === void 0 ? void 0 : _a.type) === "IMAGE" &&
                workingVariantMode.value !== "MULTI_VARIANT") {
                return "component-variable--bordered-flex";
            }
            return "";
        });
        const errorClass = computed(() => {
            return {
                "component-variable--error": !!error.value,
            };
        });
        return (_ctx, _cache) => {
            return (_unref(componentSettingMutable) && _unref(builtComponentSetting))
                ? _withDirectives((_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["component-variable-v2", [layoutClass.value, styleClass.value, errorClass.value]])
                }, [
                    _createElementVNode("div", _hoisted_1, [
                        (_ctx.showHeader)
                            ? (_openBlock(), _createBlock(ComponentVariableHeader, {
                                key: 0,
                                displayName: _unref(builtComponentSetting).getDisplayName(),
                                description: _unref(builtComponentSetting).getDescription(),
                                isAdvanced: _unref(builtComponentSetting).isAdvanced(),
                                importance: _unref(builtComponentSetting).getImportance()
                            }, _createSlots({ _: 2 /* DYNAMIC */ }, [
                                (!_unref(componentSettingMutable).isNew() &&
                                    isComponentVariableMutable.value &&
                                    source.value &&
                                    hasDisplayableNodeType.value &&
                                    _unref(componentVariableNodeType))
                                    ? {
                                        name: "prefix",
                                        fn: _withCtx(() => [
                                            _createVNode(ComponentVariableNodeIcon, {
                                                componentId: props.componentId,
                                                variableName: props.variableName,
                                                "variable-node-type": _unref(componentVariableNodeType),
                                                source: source.value
                                            }, null, 8 /* PROPS */, ["componentId", "variableName", "variable-node-type", "source"])
                                        ]),
                                        key: "0"
                                    }
                                    : undefined,
                                (!_unref(componentSettingMutable).isNew())
                                    ? {
                                        name: "postfix",
                                        fn: _withCtx(() => [
                                            _createVNode(ComponentVariableKebabMenu, {
                                                componentMutableKey: _ctx.componentMutableKey,
                                                componentId: _ctx.componentId,
                                                "variable-name": _unref(builtComponentSetting).name
                                            }, null, 8 /* PROPS */, ["componentMutableKey", "componentId", "variable-name"])
                                        ]),
                                        key: "1"
                                    }
                                    : undefined
                            ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["displayName", "description", "isAdvanced", "importance"]))
                            : _createCommentVNode("v-if", true),
                        (isComponentVariableMutable.value)
                            ? (_openBlock(), _createBlock(ComponentVariableValues, {
                                key: 1,
                                componentId: _ctx.componentId,
                                campaignId: _unref(builtComponentSetting).context.campaignId,
                                variableName: _ctx.variableName,
                                componentMutableKey: _ctx.componentMutableKey,
                                "variant-display-mode": workingVariantMode.value
                            }, null, 8 /* PROPS */, ["componentId", "campaignId", "variableName", "componentMutableKey", "variant-display-mode"]))
                            : (isComponentSocketMutable.value)
                                ? (_openBlock(), _createBlock(ComponentSocketValues, {
                                    key: 2,
                                    componentId: _ctx.componentId,
                                    "setting-name": _ctx.variableName,
                                    componentDrawerRouteConfig: props.componentDrawerRouteConfig
                                }, null, 8 /* PROPS */, ["componentId", "setting-name", "componentDrawerRouteConfig"]))
                                : _createCommentVNode("v-if", true)
                    ]),
                    (_unref(componentVariableNodeType))
                        ? (_openBlock(), _createBlock(ComponentVariableFooter, {
                            key: 0,
                            variableName: _ctx.variableName,
                            componentId: _ctx.componentId,
                            "component-mutable-key": _ctx.componentMutableKey,
                            "node-type": _unref(componentVariableNodeType)
                        }, null, 8 /* PROPS */, ["variableName", "componentId", "component-mutable-key", "node-type"]))
                        : _createCommentVNode("v-if", true),
                    _createVNode(_Transition, { name: "fade" }, {
                        default: _withCtx(() => [
                            (isLoading.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
                                : _createCommentVNode("v-if", true)
                        ]),
                        _: 1 /* STABLE */
                    })
                ], 2 /* CLASS */)), [
                    [_vShow, isShown.value]
                ])
                : _createCommentVNode("v-if", true);
        };
    }
});
